import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Provider } from "@/context/headerContext";
import { Footer, Header, PageSpinner } from "../";
import HeaderV2 from "../HeaderV2/HeaderV2";
import { ComponentVersionSwitch } from "../versionSwitch/ComponentVersionSwitch";
import { Box } from "@mui/material";

export default function Layout() {
  const { user } = useAuth();
  const location = useLocation();
  const isV2Pathname = location.pathname.includes('/administrationv2');

  return (
    <Provider>
      <ComponentVersionSwitch envKey={'REACT_APP_LAYOUT_V2'} OldComponent={Header} NewComponent={HeaderV2} />
        <Box sx={isV2Pathname ? { backgroundColor: 'var(--silver-100)'} : null}>
          <main>{user?.id ? <Outlet /> : <PageSpinner isOpen />}</main>
        </Box>
      <Footer />
    </Provider>
  );
}
